import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext.jsx';

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const { isAuthenticated, user, isInitialized } = useAuth();
  const location = useLocation();

  if (!isInitialized) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Redirect to login with return url
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }

  // Partner approval gating: if allowedRoles includes 'partner', ensure partnerApproved flag
  if (allowedRoles.includes('partner')) {
    // If user is not a partner role, redirect to their dashboard
    if (user?.role !== 'partner') {
      const redirectMap = {
        'user': '/app',
        'admin': '/admin',
        'technician': '/technician',
      };
      const redirectTo = redirectMap[user?.role] || '/';
      return <Navigate to={redirectTo} replace />;
    }

    // If partner but not approved, redirect to partner application submitted / pending page
    if (user && user.role === 'partner' && user.partnerApproved === false) {
      return <Navigate to="/partner/application-submitted" replace />;
    }
  } else if (allowedRoles.length > 0 && !allowedRoles.includes(user?.role)) {
    // Other role-based redirects
    const redirectMap = {
      'user': '/app',
      'partner': '/partner',
      'admin': '/admin',
      'technician': '/technician',
    };
    const redirectTo = redirectMap[user?.role] || '/';
    return <Navigate to={redirectTo} replace />;
  }

  return children;
};

export default ProtectedRoute;